import { Typography } from 'antd'
import { Link } from 'react-router-dom'

import { useClusters } from '@/hooks/useClusters'

interface Props {
  clusterId: string
}

export function ClusterNameLink({ clusterId }: Props) {
  const cluster = useClusters().find((c) => c.id === clusterId)

  return (
    <Link
      to={`/clusters/${clusterId}`}
      style={{
        textDecoration: 'underline',
        textDecorationStyle: 'dotted',
        textUnderlineOffset: 4,
      }}
    >
      <Typography.Text copyable={{ text: clusterId }}>
        {cluster?.name ?? `${clusterId.slice(0, 8)}...`}
      </Typography.Text>
    </Link>
  )
}
